<template>
  <li
    id="clear__section"
    @click="clearFilters"
  >
    <GjIcon
      name="Close"
      size="16"
    />
    {{ title }}
  </li>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    GjIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  methods: {
    clearFilters() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss">
#clear__section {
    list-style: none;
    cursor: pointer;
    border-top: 1px solid #E0E5EB;
    height: 34px;
    padding: 0px 4px 0px 12px;
    font-weight: 400;
    color: #0c101e;
    line-height: 34px;
    font-size: 14px;
    &:active,
    &:focus,
    &:hover {
        background-color: #fafafa;
    }
    }
</style>
